import React from "react";
import { sanitizeCssValue } from "../sanitize";

const sizeOptions = [
  { label: "S", value: "s" },
  { label: "M", value: "m" },
];

const alignOptions = [
  { label: "Left", value: "left" },
  { label: "Center", value: "center" },
  { label: "Right", value: "right" },
];

const colorOptions = [
  { label: "Default", value: "default" },
  { label: "Muted", value: "muted" },
];

const TextBlock = {
  label: "Text",
  fields: {
    text: { type: "textarea", contentEditable: true },
    size: { type: "select", options: sizeOptions },
    align: { type: "radio", options: alignOptions },
    color: { type: "radio", options: colorOptions },
    maxWidth: { type: "text" },
  },
  defaultProps: {
    text: "Text",
    size: "m",
    align: "left",
    color: "default",
    maxWidth: undefined,
  },
  render: ({ text, size, align, color, maxWidth }) => {
    return (
      <span
        style={{
          color: color === "default" ? "inherit" : "var(--puck-color-grey-05)",
          display: "flex",
          textAlign: align,
          width: "100%",
          fontSize: size === "m" ? "20px" : "16px",
          fontWeight: 300,
          maxWidth: sanitizeCssValue(maxWidth, undefined),
          justifyContent:
            align === "center"
              ? "center"
              : align === "right"
              ? "flex-end"
              : "flex-start",
        }}
      >
        {text}
      </span>
    );
  },
};

export default TextBlock;
